import { type ReactElement, useSyncExternalStore } from "react";

import { Button } from "@/components/ui/button";
import {
  openSignInWindow,
  renewalPending,
  subscribeRenewal,
} from "@/lib/session-renewal";

/**
 * While an expired session is being renewed: what happened, and the button that opens the
 * sign-in window when the browser blocked the one opened without a click.
 */
export function SessionRenewalNotice(): ReactElement | null {
  const pending = useSyncExternalStore(subscribeRenewal, renewalPending);
  if (!pending) {
    return null;
  }
  return (
    <div
      role="alert"
      className="fixed inset-x-0 top-0 z-50 flex flex-wrap items-center justify-center gap-3 border-b bg-background px-4 py-3 text-sm shadow"
    >
      <span>Die Anmeldung ist abgelaufen. Ihre Eingaben bleiben erhalten.</span>
      <Button size="sm" onClick={() => openSignInWindow()}>
        Neu anmelden
      </Button>
    </div>
  );
}
